<template>
	<div class="updateNum">
		<van-nav-bar
		  	:title="$t('UpdateNum.title')"
		  	@click-left="$router.push('/checkNum')"
			left-arrow>
		</van-nav-bar>
		<p>{{$t('UpdateNum.text')}}</p>
		<input type="text" 
				readonly
				placeholder="+86"
			  	@click="showPicker = true"
			  	:value="areaName"
			  	class="chooseAreaName" 
			  	/>
		<van-popup v-model="showPicker" position="bottom">
		  	<van-picker
			    show-toolbar
			    :columns="columns"
			    @cancel="showPicker = false"
			    @confirm="onConfirm"
				:confirm-button-text="$t('vantText.confirm')"
				:cancel-button-text="$t('vantText.cancel')"
		  	/>
		</van-popup>
		<van-cell-group>
			<van-field
				label=''
				v-model="phone"
				clearable
				:placeholder="$t('UpdateNum.input')"
			>
			</van-field>
		</van-cell-group>
		<div class="wrap">
			<van-field		
				v-model="smscode"			
				clearable
				:placeholder="$t('UpdateNum.inputSMS')"
			 	>
		 	</van-field>
		</div>		
		<van-button v-if='isSms==false' class="check" round type="default"  style="font-weight:bold;font-size:16px;" @click="sendCode();" >{{$t('UpdateNum.SMS')}}</van-button>
		<van-button v-else class='disableCheck' round type="default" style="font-weight:bold;font-size:8px;" :disabled='isSms'><span>{{timer}}</span>{{$t('UpdateNum.retrieve')}}</van-button>
		<van-button class="certainBtn" round type="default"  style="font-weight:bold;font-size:16px;" @click=certain()>{{$t('UpdateNum.certain')}}</van-button>
	</div>
  
</template>

<script>
export default {
	data(){
		return{
			areaName:localStorage.getItem('areaName')||'',
			areacode:localStorage.getItem('areacode')||'',
			phone:'',
			smscode:'',
			smskey:'',
			showPicker: false,
      		columns: [],
      		isSms:false,
			timer:60,
			getLangs:''
		}
	},
	mounted:function(){
		this.getAreacode();
		this.getLangs = this.$i18n.locale;
    },
	methods:{
		onConfirm(value,index) {
	      	this.areacode = this.columns[index].acnumber;
	      	this.areaName =value.text;
	      	localStorage.setItem('areacode',this.areacode);
	      	localStorage.setItem('areaName',this.areaName);
	      	this.showPicker = false;
    	},
    	getAreacode(){
    		this.$axios({
                method: 'get',
                url: this.$build+'/api/areacode',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
                	this.columns=res.data.data;
                	for(var i = 0;i<this.columns.length;i++){
                		if(this.getLangs=='en'){
							this.columns[i].text=this.columns[i].acname_en+'('+this.columns[i].acnumber+')';
						}else if(this.getLangs=='hk'){
							this.columns[i].text=this.columns[i].acname_hk+'('+this.columns[i].acnumber+')';
						}else if(this.getLangs=='zh'){
							this.columns[i].text=this.columns[i].acname_cn+'('+this.columns[i].acnumber+')';
						}else{
							this.columns[i].text=this.columns[i].acname_en+'('+this.columns[i].acnumber+')';
						}
                	}
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('UpdateNum.message'),
        		});
            });
		},
		sendCode(){
			if(this.phone){
				this.$axios({
                method: 'post',

                url: this.$build+'/api/send',
                data:{
                	area_code:this.areacode,
                	phone:this.phone,
                },
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
                	this.$toast({
	            		type:'success',
	            		message:res.data.message,
	            	});   
	            	this.isSms=true;        	
	            	this.smskey=res.data.success.key;
	            	const vm=this;	
	            	vm.isSms=true;
	            	var countdown=setInterval(()=>{
	            		this.timer--;
	            		if(this.timer<=0){
	            			vm.isSms=false;
	            			clearInterval(countdown);
	            		}
	            	},1000)
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('UpdateNum.message'),
        		});
            });
		}else{
			this.$toast(this.$t('UpdateNum.inputPhone'));
		}
			
	},
		certain(){
			if(this.smscode && this.phone){
				this.$axios({
					method:'post',
					headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
					url:this.$build+'/api/user/relate',
					data:{
						key:this.smskey,
						code:this.smscode,
						area_code:this.areacode,
						phone:this.phone
					},
				}).then(res => {
					console.log(res);
					if(res.data.status==200){
						this.$toast({
		            		type:'success',
		            		message:res.data.message,
		            	});
		            	const vm=this;
		            	setTimeout(function(){
		            		console.log(1111111);
	            			vm.$router.push('/');
		            	},1500);
					}else{
						for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
					}
				}).catch(err =>{
					this.$toast({
	            		type:'fail',
	            		message:this.$t('UpdateNum.fail'),
            		});
				})
			}else{
				this.$toast(this.$t('UpdateNum.toast'));
			}		
		}
	}

}
</script>

<style scoped>
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color:#2f75f7;
	}
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-picker-column{
		z-index: 9
	}
	/deep/ .van-overlay{
		height: 96%;
	}
	.van-field{
		color: #000;
	}
	.updateNum{
		width: 100%;
		height: 100vh;
		background: #fff;
	}
	.updateNum>div{margin-bottom: 20px;}
	.van-field{
		border-radius: 23px;
		border: 2px solid #000;
		color: #FFB20D;
		width: 90%;
		margin-left: 5%;
		position: relative;
	}
	p{
		margin-top: 17px;
		color: #888;
		text-align: center;
		font-size: 14px;
		margin-bottom: 30px;
	}
	.wrap{
		width: 60%;
		float: left;
		margin-left: 2%;
	}
	.check{
		width: 30%;            
		background: #2f75f7;
		color: #fff;
		line-height: 16px;
		float: right;
		margin-right: 5%;
	}
	.disableCheck{           
		background: #DFDEDE;
		line-height: 34px;
		float: right;
		margin-right: 5%;
		font-size: 9px;
	}
	.certainBtn{
		width: 90%;
		height: 40px;
		line-height: 40px;
		margin-left: 5%;
		margin-top: 10px;
		background:#000;
		color: #fff;
		font-weight: bold;
		border: none;
	}
	.chooseAreaName{
		position: absolute;
		z-index: 9;
		margin-top: 13px;
		margin-left: 30px;
		background: transparent;
		border: none;
		width: 90px;
		font-size: 14px;
	}
</style>


// WEBPACK FOOTER //
// src/components/UpdateNum.vue